import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    editingState: null,
};

export const commentSlice = createSlice({
    name: "commentDetails",
    initialState,
    reducers: {
        setReplyState: (state, action) => {
            state.editingState = action.payload;
        },
    },
});

export const { setReplyState } = commentSlice.actions;
export default commentSlice.reducer;
